// Live references shared between the in-canvas game and DOM HUD overlays.
// FPSGame writes here; the Minimap (and future overlays) read from here.
// Avoids prop drilling through <MatchScreen> and keeps the R3F world
// isolated from React reconciliation.
export const matchRefs = {
    player: null,       // { position: {x,y,z}, rotation: {y} }
    bots: [],           // live bots array
};
